import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Fade animation class.
 */
export default class Fade extends withIntersectionObserver(Base, {
  threshold: 0.3,
}) {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Fade',
    options: {
      delay: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   * Launch the fade-in animation.
   */
  launchAnimation() {
    this.$el.style.transitionDelay = `${this.$options.delay}s`;

    if (this.$el.classList.contains('inview')) {
      return;
    }

    this.$el.classList.add('inview');
  }
}
